// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "-" + {"27":"15c62c55","348":"ed0a7efd","571":"cad887cf","924":"5be2142b"}[chunkId] + ".chunk.js";
};